import React, {useState, useEffect} from 'react';
import { Typography, Box, Divider, List, ListItem, ListItemAvatar,Avatar, ListItemText } from '@mui/material';
import { Description , } from '@mui/icons-material';
import LinkIcon from '@mui/icons-material/Link';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import FolderIcon from '@mui/icons-material/Folder';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';


const ResourcesListCompact = ({eventDocId}) =>{
    
    const [resources, setResources] = useState([]);
    const [error, setError] = useState('');

      useEffect(() => {
        if (eventDocId) {
          fetchResources();
        }
      }, [eventDocId]);


  const fetchResources = async () => {
    try {
      const resourcesSnapshot = await getDocs(collection(db, 'events', eventDocId, 'resources'));
      const resourcesData = resourcesSnapshot.docs.map((doc) => doc.data());
      setResources(resourcesData);
    } catch (err) {
      setError('Failed to fetch resources.');
      console.error(err);
    }
  };

    return(
        <Box
        flexGrow={1}
        padding={1}
        sx={{bgcolor: 'background.paper', borderRadius:3,}}>
          <Typography variant="h5"  color='text.primary'> Resources</Typography>
          {/* <Typography variant="subtitle1"> People</Typography> */}
       
       <List> 
        {resources.length > 0 ? (
           resources.map((resource, index) => ( 
                <ListItem key={index}
                  secondaryAction={
                    <a href={resource.resourceURL} target="_blank" rel="noopener noreferrer">                                                   
                    <IconButton edge="end" aria-label="delete">
                      <LinkIcon />
                    </IconButton>
                    </a>  
                  }                  
                >
                  <ListItemAvatar>
                    <Avatar>
                      <FolderIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText>
                    <Typography variant="body1"  color='text.primary'> {resource.resourceName }</Typography>
                  </ListItemText>                  
                </ListItem>                                  
           ))
          ) : (
            <Typography variant="body2">No resources found.</Typography>
          )}         
            </List>
       </Box>     
    );
}
export default ResourcesListCompact;